import type { JSX } from 'react'

import { TextBoxMaxLine1Button2Center, TextBoxMaxLine1Caption3 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { $signInFormTranslations } from './i18n'

export const SignUpLink = ({
  sighUpRedirectLink,
}: {
  sighUpRedirectLink: string
}): JSX.Element => {
  const formTranslations = useUnit($signInFormTranslations)

  return (
    <>
      <TextBoxMaxLine1Caption3 title={formTranslations.redirectQuestion} />
      <a href={sighUpRedirectLink}>
        <TextBoxMaxLine1Button2Center title={formTranslations.redirectLink} />
      </a>
    </>
  )
}
